import React from "react";

const R2RInfoTextFake = () => {
  return (
    <>
    <div className="r2r-info-fake-container">
      <div className="skeleton r2r-info-fake" />
      <div className="skeleton r2r-info-fake" />
    </div>
    <style jsx>{`
      .r2r-info-fake-container {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
      }
      .r2r-info-fake {
        height: 16px;
        width: 70%;
      }
      `}</style>
    </>
  )
}

export default R2RInfoTextFake;